import AssignedProductTable from './assignedProductTable.container';

export default AssignedProductTable